import React, { useContext, useState } from 'react'
import LogoTop from '../../../Layout/LogoTop'
import {
  Paper,
  Button, Grid, useTheme
} from '@mui/material'
import { useNavigate } from 'react-router-dom';

import './Paciente.css'
import CabecalhoTela from '../Componentes/CabecalhoTela';
import BackEndAPI from '../../../Services/BackEndAPI';
import { ContextoGlobal, ContextoGlobalInterface } from '../../../GlobalStates/ContextoGlobal';
import { MensagemTipo } from '../../../GlobalStates/MensagemState';
import ExibirJSONDev from '../../../DevComponents/ExibirJSONDev';
import InputText from '../../../DevComponents/InputText';
import ClsValidacao from '../../../Utils/ClsValidacao';
import { RespostaPadraoInterface } from '../../../ImportBackend/Interfaces/PadraoInterfaces';

export default function TrocarSenha() {

  const clsApi = new BackEndAPI()

  const contexto = useContext(ContextoGlobal) as ContextoGlobalInterface

  const [erros, setErros] = useState<Record<string, string>>({})

  const [dados, setDados] = useState({
    senha: '',
    novaSenha: '',
    confirmacaoNovaSenha: '',
  })

  const [exibirSenhaState, setExibirSenhaState] = useState(false)

  const abortController: AbortController = new AbortController()

  const theme = useTheme()

  const nav = useNavigate()

  const btOpcao = (caminho: string) => {
    nav(caminho)
  }

  const btConfirmarTrocaSenha = () => {
    if (validarDados()) {

      const mutation = `
        alterarSenhaPaciente (senhaAtual: "${dados.senha}", novaSenha: "${dados.novaSenha}") {
          ok
          mensagem
        }
      `

      clsApi.mutation<RespostaPadraoInterface>(mutation, 'alterarSenhaPaciente', 'Alterando Senha...', contexto, abortController).then(rsAlterarSenha => {

        if (rsAlterarSenha.ok) {
          btOpcao('/LoginPaciente')
        } else {

          contexto.setMensagemState({
            cb: null,
            exibir: true,
            exibirBotao: true,
            mensagem: 'Tente Novamente. Se persistir, consulte a Vamos Sorrir.',
            tipo: MensagemTipo.Error,
            titulo: 'Erro ao Alterar Senha!'
          })

        }

      })

    }
  }

  const handleExibirSenha = () => {
    setExibirSenhaState(!exibirSenhaState)
  }

  const validarDados = (): boolean => {

    let retorno: boolean = true
    let erros: { [key: string]: string } = {}

    let clsValidacao = new ClsValidacao()

    retorno = clsValidacao.naoVazio('senha', dados, erros, retorno)
    retorno = clsValidacao.naoVazio('novaSenha', dados, erros, retorno)
    retorno = clsValidacao.naoVazio('confirmacaoNovaSenha', dados, erros, retorno)

    if (retorno) {
      if (dados.novaSenha !== dados.confirmacaoNovaSenha) {
        retorno = false
        erros['confirmacaoNovaSenha'] = 'A confirmação da nova senha não confere.'
      }
    }

    setErros(erros)

    return retorno
  }

  return (
    <>
      <div className='imagemFundoBranco'>

        <LogoTop />

        <Grid
          container
          minHeight='100VH'
        >

          <Grid item xs={12} md={5} sx={{ margin: 'auto' }}>

            <Grid container>

              <Grid item xs={12} mb={5}>

                <CabecalhoTela titulo={'Troque sua senha'} />

              </Grid>

              <Grid item xs={11} sx={{ mt: 2 }}>
                <Paper sx={{ backgroundColor: theme.cores.cinzaFundo, padding: 2, mb: 2 }}>

                  <Grid container>

                    <Grid item xs={12} mt={2}>

                      <InputText
                        dados={dados}
                        field='senha'
                        label='Senha'
                        type={exibirSenhaState ? "text" : "password"}
                        setState={setDados}
                        iconeEnd='visibility'
                        onClickIconeEnd={handleExibirSenha}
                        erros={erros}
                      />

                    </Grid>

                    <Grid item xs={12} mt={2}>

                      <InputText
                        dados={dados}
                        field='novaSenha'
                        label='Nova Senha'
                        type={exibirSenhaState ? "text" : "password"}
                        setState={setDados}
                        iconeEnd='visibility'
                        onClickIconeEnd={handleExibirSenha}
                        erros={erros}
                      />

                    </Grid>

                    <Grid item xs={12} mt={2}>

                      <InputText
                        dados={dados}
                        field='confirmacaoNovaSenha'
                        label='Confirmar Nova Senha'
                        type={exibirSenhaState ? "text" : "password"}
                        setState={setDados}
                        iconeEnd='visibility'
                        onClickIconeEnd={handleExibirSenha}
                        erros={erros}
                      />

                    </Grid>

                  </Grid>

                  <Grid item xs={12} px={3} my={4}>
                    <Button
                      fullWidth
                      variant='contained'
                      onClick={() => btConfirmarTrocaSenha()}
                      sx={{ borderRadius: 2, backgroundColor: theme.palette.secondary.main }}>
                      Confirmar Troca
                    </Button>
                  </Grid>

                </Paper>

              </Grid>


              <Grid item xs={12} sx={{ textAlign: 'center' }}>
                <Button
                  onClick={() => btOpcao('/PacienteMenu')}
                  sx={{
                    color: theme.palette.secondary.main,
                    fontWeight: 'bold',
                    mb: 2
                  }}
                  variant='text'>Voltar
                </Button>
              </Grid>

              <img alt='Vamos Sorrir Publicidade' src="/imagens/paciente/bannermenupaciente.png" width={'100%'} />

            </Grid>

          </Grid>

        </Grid>

        <ExibirJSONDev oque={[
          'Token',
          'Dados'
        ]}></ExibirJSONDev>

      </div>
    </>
  )

}